/**
 * 机上調査の新方式で AI に送る内容のプレビュー (docs/27 §15-6 / §17-4)。functions と同じ shared-types の
 * 組立関数を使う。選抜の候補の一覧は解析時に入るため、候補なしで表示する。
 */
import {
  buildStreetSurveyDirectionPrompt,
  buildStreetSurveySelectionPrompt,
  STREET_SURVEY_DIRECTION_LABELS,
  type ResolvedStreetSurveyExtraction,
  type StreetSurveyMastersById,
} from '@citizen-walk/shared-types';

export interface StreetSurveyPromptPreviewProps {
  cfg: ResolvedStreetSurveyExtraction;
  mastersById: StreetSurveyMastersById;
}

export function StreetSurveyPromptPreview({ cfg, mastersById }: StreetSurveyPromptPreviewProps) {
  if (!cfg.anchor) return null;
  const directionPrompt = buildStreetSurveyDirectionPrompt(cfg, mastersById, 0);
  const selectionPrompt = buildStreetSurveySelectionPrompt(cfg, mastersById, []);
  return (
    <>
      <details className="rounded border border-slate-200 bg-slate-50 px-2 py-1">
        <summary className="cursor-pointer text-xs text-slate-700">
          AI に送る内容のプレビュー: 方向ごとの解析（{STREET_SURVEY_DIRECTION_LABELS[0]}、
          {directionPrompt.length.toLocaleString()} 文字）
        </summary>
        <pre className="mt-1 max-h-96 overflow-auto whitespace-pre-wrap text-[11px] text-slate-700">
          {directionPrompt}
        </pre>
      </details>
      <details className="rounded border border-slate-200 bg-slate-50 px-2 py-1">
        <summary className="cursor-pointer text-xs text-slate-700">
          AI に送る内容のプレビュー: 4 方向をまとめた選抜（候補の一覧は解析時に入ります、
          {selectionPrompt.length.toLocaleString()} 文字）
        </summary>
        <pre className="mt-1 max-h-96 overflow-auto whitespace-pre-wrap text-[11px] text-slate-700">
          {selectionPrompt}
        </pre>
      </details>
    </>
  );
}
